import React from "react";
import clxs from "./lohono-luma-intro.module.css";
import POOL_IMAGE from "../../../assets/luma-bg.webp";
import LUMA_LOGO from "../../../assets/logo/luma-logo.svg";
import LUMA_OFFER_ICON_2 from "../../../assets/water_lux.svg";
import LUMA_OFFER_ICON_3 from "../../../assets/currency_rupee_black_circle.svg";
import LUMA_OFFER_ICON_4 from "../../../assets/pickleball.svg";
import LUMA_OFFER_ICON_1 from "../../../assets/holiday_village.svg";
import useClx from "../../../hooks/use-clx";

interface LohonoLumaIntroProps {
  className?: string;
}

function LohonoLumaIntro(props: LohonoLumaIntroProps) {
  const { className } = props,
    ccx = useClx(clxs.container, className);
  const lumaOffers = [
    {
      icon: LUMA_OFFER_ICON_1,
      title: "Luxury Stays",
      description: "2.5 & 3 Bedroom villas with amenities",
    },
    {
      icon: LUMA_OFFER_ICON_2,
      title: "Private Pools",
      description: "Each villa features a private pool",
    },
    {
      icon: LUMA_OFFER_ICON_3,
      title: "Accessible Luxury",
      description: "Trusted Lohono hospitality, now at an easier price point",
    },
    {
      icon: LUMA_OFFER_ICON_4,
      title: "Community Spaces",
      description: "Gym, Pickleball Court, Coffee Bar, Play Areas & more",
    },
  ];

  return (
    <div className={ccx}>
      {/* Top Section */}
      <div className={clxs.introSection}>
        <div className={clxs.textBlock}>
          <div className={clxs.introducing}>Introducing</div>
          <img
            src={LUMA_LOGO}
            alt="Lohono Luma"
            className={clxs.logo}
          />

          <div className={clxs.description}>
            <div className={clxs.heading}>Luxury begins here</div>
            Your introduction to the world of Lohono. Luma brings together luxury villas, intuitive hospitality, and thoughtfully created community spaces - all at an easier price point.          </div>
          <a 
            className={`${clxs.ctaButton} ${clxs.introducingCta}`}
            href={"/villas/collections/lohono_luma"}
          >
            Explore Lohono Luma
          </a>
        </div>

        <div className={clxs.imageBlock}>
          <img
            src={POOL_IMAGE}
            alt="Luma Pool"
            className={clxs.poolImage}
          />
          <div className={clxs.imageGradient} />
        </div>
      </div>

      {/* Offer Section */}
      <div className={clxs.offersSection}>
        <div className={clxs.offersHeading}>Our Luma Villas Offer</div>
        <div className={clxs.offerItems}>
          {lumaOffers.map((item, index) => (
            <div
              className={clxs.offerContainer}
              key={index}
            >
              <div className={clxs.offer}>
              <img
                src={item.icon}
                alt={item.title}
              />
              <div className={clxs.offerContent}>
                <div className={clxs.offerTitle}>{item.title}</div>
                {item.description}
              </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Footer Section */}
      <div className={clxs.footerBanner}>
        <div className={clxs.footerText}>
          Step into a world of luxury holidays 
        </div>
        <a 
          className={clxs.ctaButton}
          href={"/villas/collections/lohono_luma"}
        >Explore Lohono Luma</a>
      </div>
    </div>
  );
}

export default LohonoLumaIntro;
